import { SeatChartData, SeatInfo } from '../types/seatTypes';

/**
 * seatChart JSON string을 파싱하여 SeatInfo 배열로 변환
 */
export const parseSeatChart = (seatChartString: string | null | undefined): SeatInfo[] => {
  if (!seatChartString) {
    return [];
  }

  try {
    const parsed: SeatChartData = JSON.parse(seatChartString);
    return parsed.seats || [];
  } catch (error) {
    console.error('Failed to parse seatChart:', error);
    return [];
  }
};

/**
 * SeatInfo 배열을 JSON string으로 변환
 */
export const stringifySeatChart = (seats: SeatInfo[]): string => {
  const seatChartData: SeatChartData = {
    seats,
    metadata: {
      lastUpdated: new Date().toISOString(),
      version: '1.0',
    },
  };

  return JSON.stringify(seatChartData);
};

/**
 * SeatInfo 유효성 검사
 */
export const validateSeatInfo = (seat: Partial<SeatInfo>): seat is SeatInfo => {
  return (
    typeof seat.seatId === 'string' &&
    seat.seatId.length > 0 &&
    typeof seat.x === 'number' &&
    typeof seat.y === 'number' &&
    typeof seat.teamColor === 'string'
  );
};

/**
 * 좌석 ID 생성 (좌표 기반)
 */
export const generateSeatId = (x: number, y: number): string => {
  return `seat-${Math.round(x)}-${Math.round(y)}`;
};

/**
 * 좌석 데이터 병합 (기존 데이터 + 새 데이터)
 */
export const mergeSeatData = (existingSeats: SeatInfo[], newSeat: SeatInfo): SeatInfo[] => {
  const existingIndex = existingSeats.findIndex((s) => s.seatId === newSeat.seatId);

  if (existingIndex >= 0) {
    const updatedSeats = [...existingSeats];
    updatedSeats[existingIndex] = newSeat;
    return updatedSeats;
  }

  return [...existingSeats, newSeat];
};

/**
 * 좌석 데이터에서 특정 좌석 찾기
 */
export const findSeatById = (seats: SeatInfo[], seatId: string): SeatInfo | undefined => {
  return seats.find((s) => s.seatId === seatId);
};

/**
 * 좌석 데이터에서 특정 직원 좌석 찾기
 */
export const findSeatByEmployeeId = (
  seats: SeatInfo[],
  employeeId: number,
): SeatInfo | undefined => {
  return seats.find((s) => s.employeeId === employeeId);
};

/**
 * 중복 직원 배치 확인
 */
export const checkDuplicateEmployee = (
  seats: SeatInfo[],
  employeeId: number,
  excludeSeatId?: string,
): boolean => {
  if (!employeeId || employeeId === 0) return false;

  return seats.some((s) => s.employeeId === employeeId && s.seatId !== excludeSeatId);
};
